import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import "./scss/index.scss";
import React from "react";
import { Button, OverlayTheme, OverlayType } from "..";
import { RudderAnalytics } from "../../app/analitics";
import { commonMessages } from "../../intl";
import { withIntlsHOC } from "../Locale";
import { QuantityTextField } from "./QuantityTextField";
import cartIcon from "../../images/cart_white.svg";
var LOW_STOCK_QUANTITY = 5;

var AddToCart =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AddToCart, _React$Component);

  function AddToCart() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, AddToCart);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AddToCart)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      quantity: 1
    }, _this.getVariantStock = function () {
      var _this$props = _this.props,
          variantId = _this$props.variantId,
          productVariants = _this$props.productVariants;
      var selectedVariant = productVariants.find(function (pv) {
        return pv.id === variantId;
      });
      return selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantityAvailable;
    }, _this.canAddToCart = function () {
      var _this$props2 = _this.props,
          variantId = _this$props2.variantId,
          items = _this$props2.items;
      var quantity = _this.state.quantity;

      var variantStock = _this.getVariantStock();

      var quantityInCart = (items === null || items === void 0 ? void 0 : items.reduce(function (acc, cur) {
        if (cur.variant.id === variantId) {
          return acc + cur.quantity;
        }

        return acc;
      }, 0)) || 0;
      var syncedQuantityWithCart = quantity + quantityInCart;
      return quantity !== 0 && variantId && variantStock >= syncedQuantityWithCart;
    }, _this.handleSubmit =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _item$variant, _item$variant$product;

      var _this$props3, onAddToCart, overlayContext, quantity, _this$props4, items, productId, variantId, item;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props3 = _this.props, onAddToCart = _this$props3.onAddToCart, overlayContext = _this$props3.overlayContext;
              quantity = _this.state.quantity;
              _context.next = 4;
              return onAddToCart(quantity);

            case 4:
              _this.setState({
                quantity: 1
              });

              overlayContext.show(OverlayType.cart, OverlayTheme.right); // @ analytics

              _this$props4 = _this.props, items = _this$props4.items, productId = _this$props4.productId, variantId = _this$props4.variantId;
              item = items === null || items === void 0 ? void 0 : items.find(function (o) {
                return o.variant.id === variantId;
              }); // TagManager.dataLayer({
              //   dataLayer: {
              //     ecommerce: {
              //       add: {
              //         products: [
              //           {
              //             id: productId,
              //             name: item.variant?.product?.name,
              //             variant: variantId,
              //           },
              //         ],
              //       },
              //     },
              //     event: "addToCart",
              //   },
              // });

              RudderAnalytics.track("Product Added", {
                name: (_item$variant = item.variant) === null || _item$variant === void 0 ? void 0 : (_item$variant$product = _item$variant.product) === null || _item$variant$product === void 0 ? void 0 : _item$variant$product.name,
                product_id: productId,
                variant: variantId
              }, null, null);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this.getAvailableQuantity = function () {
      var _this$props5 = _this.props,
          variantId = _this$props5.variantId,
          items = _this$props5.items;

      var variantStock = _this.getVariantStock();

      var quantityInCart = (items === null || items === void 0 ? void 0 : items.reduce(function (acc, cur) {
        if (cur.variant.id === variantId) {
          return acc + cur.quantity;
        }

        return acc;
      }, 0)) || 0;
      return variantStock - quantityInCart;
    }, _this.handleQuantityChange = function (quantity) {
      _this.setState({
        quantity: quantity
      });
    }, _this.renderErrorMessage = function (message) {
      return React.createElement("p", {
        className: "add-to-cart__error-message"
      }, message);
    }, _temp));
  }

  _createClass(AddToCart, [{
    key: "render",
    value: function render() {
      var intl = this.props.intl;
      var _this$props6 = this.props,
          variantId = _this$props6.variantId,
          disabled = _this$props6.disabled,
          children = _this$props6.children;
      var quantity = this.state.quantity;
      var variantStock = this.getVariantStock();
      var availableQuantity = this.getAvailableQuantity();
      var isOutOfStock = !!variantId && variantStock === 0;
      var isNoItemsAvailable = !!variantId && !isOutOfStock && !availableQuantity;
      var isLowStock = !!variantId && !isOutOfStock && !isNoItemsAvailable && availableQuantity < LOW_STOCK_QUANTITY;
      var errors = [];

      if (isOutOfStock) {
        errors.push({
          message: intl.formatMessage(commonMessages.outOfStock)
        });
      }

      if (isLowStock) {
        errors.push({
          message: intl.formatMessage(commonMessages.lowStock)
        });
      }

      if (isNoItemsAvailable) {
        errors.push({
          message: intl.formatMessage(commonMessages.noItemsAvailable)
        });
      }

      return React.createElement("div", {
        className: "add-to-cart"
      }, React.createElement("div", {
        className: "add-to-cart__quantity-input"
      }, React.createElement(QuantityTextField, {
        quantity: quantity,
        maxQuantity: availableQuantity,
        disabled: isOutOfStock || isNoItemsAvailable,
        onQuantityChange: this.handleQuantityChange,
        hideErrors: !variantId || isOutOfStock || isNoItemsAvailable,
        errors: errors
      })), React.createElement("div", {
        className: "add-to-cart__buttons"
      }, children, React.createElement(Button, {
        className: "red",
        onClick: this.handleSubmit,
        disabled: !this.canAddToCart() || disabled
      }, React.createElement("div", {
        className: "add-to-cart__buttons-inner"
      }, intl.formatMessage(commonMessages.addToCart), React.createElement("img", {
        src: cartIcon,
        alt: "cart icon"
      })))));
    }
  }]);

  return AddToCart;
}(React.Component);

export var EnhancedAddToCart = withIntlsHOC(AddToCart);